module.exports = __webpack_public_path__ + "static/grain_restaurant-192c6e68cfb1a67e3d203a41411834e2.png";